import { render, staticRenderFns } from "./View_details.vue?vue&type=template&id=514e335b&"
import script from "./View_details.vue?vue&type=script&lang=js&"
export * from "./View_details.vue?vue&type=script&lang=js&"
import style0 from "./View_details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports